// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerWidget.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {


  var React = require('react');
  var observer = require('mobx-react').observer;

  var connect = require('share/enhancers/Izenda.Connect');
  var PropertiesEditorUtils = require('share/utils/Izenda.PropertiesEditorUtils');
  var PropertiesEditorManager = require('modules/Izenda.PropertiesEditorManager');

  const { invoke } = require('lodash/fp');

  function registerPropertiesEditor(MainComponent) {
    var ReportDesignerWidget = observer(
      React.createClass({
        propTypes: {
          propsEditors: React.PropTypes.array,
          checkRegistedItem: React.PropTypes.func,
          beforeShowProps: React.PropTypes.func,
          showPropOnMount: React.PropTypes.func,
          isRerenderOnActive: React.PropTypes.bool
        },

        isShowingPropsEditor: function() {
          var props = this.props;
          var propsEditors = props.propsEditors;
          return PropertiesEditorManager.isShowingPropsEditor(propsEditors);
        },

        getShowingComponentInfo: function() {
          var props = this.props;
          var propsEditors = props.propsEditors;
          return PropertiesEditorManager.getShowingComponentInfo(propsEditors);
        },

        componentDidUpdate: function() {
          var props = this.props;
          this.isShowingPropsEditor() && props.afterActiveEditor && props.afterActiveEditor();
        },

        render: function() {

          var props = this.props;
          var checkRegistedItem = this.props.checkRegistedItem;

          var isShowingPropsEditor =  invoke('isShowingPropsEditor', this);

          this.isRegistedItem =
            isShowingPropsEditor && (checkRegistedItem ? checkRegistedItem(this.getShowingComponentInfo()) : true);

          return (
            <MainComponent
              {...props}
              isRegistedItem={this.isRegistedItem}
              onClick={this.onClick}
              isShowingPropsEditor={this.isShowingPropsEditor}
              getShowingComponentInfo={this.getShowingComponentInfo}
            />
          );

          function onClick() {}
        },

        onClick: function() {
          var props = this.props;
          var propsEditors = props.propsEditors;

          props.onClick && props.onClick.apply(this, arguments);
          return PropertiesEditorUtils.switchToEditor(this, props, propsEditors);
        }
      })
    );
    const displayName = MainComponent.displayName || MainComponent.name;
    if(displayName) ReportDesignerWidget.displayName = `ReportDesignerWidget(${displayName})`;
    return connect({ toClass: true })(ReportDesignerWidget);
  }

  module.exports = {
    wrapper: registerPropertiesEditor
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.ReportDesignerWidget.jsx